export default __webpack_public_path__ + "static/media/CD3EA610-E2D7-4AD6-9D67-9D5680C079B9.7af81322.jpeg";